import React from 'react'; // eslint-disable-line
import HelpTooltip from '../common/HelpTooltip';

const HorizontalFormContainer = (props) => {
    return (
        <div className={props.inputClass}>
            <h3 data-qa={`label-for-${props.dataqa ? props.dataqa : props.title}`}>
                {props.title}
                {' '}
                {props.tooltipText == null ? ''
                    : (
                        <HelpTooltip
                            dataqa={props.dataqa ? props.dataqa : props.title}
                            tooltipName={props.tooltipName}
                            tooltipText={props.tooltipText}
                        />
                    )}
            </h3>

            {props.children}
        </div>
    );
};

export default HorizontalFormContainer;
